import Form from "./Form/Form.js";
import Alert from "./Utils/Alert.js";

function ShipExplorer() {
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <Form />
                </div>
            </div>

            <Alert />

            <div className="navbar navbar-expand-lg fixed-bottom bg-primary d-none">
                <div className="container-fluid">
                    <span className="navbar-text text-white">
                        Created by @NicholasJohn16. Enjoying the App? Maybe send
                        me a lockbox key or other item in-game!
                    </span>

                    <span className="navbar-text text-white">
                        Looking for a glbta+ fleet? Check out{" "}
                        <a
                            className="text-info"
                            target="_blank"
                            href="https://fleet.stonewallgaming.net"
                            rel="noreferrer"
                        >
                            Stonewall Fleet
                        </a>
                    </span>
                </div>
            </div>
        </>
    );
}

export default ShipExplorer;
